import { Draft } from "./Draft.util";
import { getCalculateProgressParams } from "./getCalculateProgressParams";

import { IContactAndBilling } from "@models/EventRegistrationForm.model";

export const getContactAndBillingProgressParams = (
  draft: Draft<IContactAndBilling>
) => {
  const {
    address,
    billingAddress,
    firstName,
    isBillingAddressSame,
    lastName,
    name,
  } = draft;

  const requiredFieldsValues = [
    address?.city,
    address?.country,
    address?.phone?.code,
    address?.phone?.number,
    address?.postCode,
    address?.streetAndHouse,
    address?.type,
    name,
    lastName,
    firstName,
  ];
  if (!isBillingAddressSame)
    requiredFieldsValues.push(
      ...[
        billingAddress?.city,
        billingAddress?.country,
        billingAddress?.phone?.code,
        billingAddress?.phone?.number,
        billingAddress?.postCode,
        billingAddress?.streetAndHouse,
        billingAddress?.type,
      ]
    );

  return getCalculateProgressParams(requiredFieldsValues);
};
